/** Route configured UAT questionnaire approvals through the backend lifecycle.
 * Only an explicit outside-pilot result permits legacy approval; errors never do.
 */
import axios from 'axios';
import { prepareFlowForReview } from './flowPreparationWS';
export async function approveFlowIfConfigured(questionnaire, getState, options = {}) {
  if (questionnaire.whatsappFlowsEnabled === false) return false;
  if (process.env.REACT_APP_FLOW_DRAFT_ADMIN !== 'true') {
    if (questionnaire.flowLifecycleManaged || questionnaire.whatsappFlowsEnabled === true)
      throw new Error('Flow approval is not enabled in this portal.');
    return false;
  }
  const session = getState().authData?.[0]?.signInUserSession;
  const config = {
    params: { tenantId: questionnaire.tenantId, questionnaireId: questionnaire.id },
    headers: { Authorization: `Bearer ${session?.accessToken?.jwtToken}` },
  };
  const base = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/whatsapp-flows`;
  let data;
  try {
    ({ data } = await axios.get(`${base}/draft`, config));
    if (questionnaire.whatsappFlowsEnabled !== true && data.whatsappFlowsEnabled === false) return false;
  } catch (error) {
    if (
      questionnaire.whatsappFlowsEnabled !== true &&
      !questionnaire.flowLifecycleManaged &&
      error.response?.status === 404 &&
      error.response?.data?.error === 'questionnaire_outside_pilot'
    )
      return false;
    throw error;
  }
  // Reuse the fenced preparation/review operation before publication. It
  // rechecks saved source content and reuses an unchanged validated asset.
  // Existing publication/reconciliation states stay owned by /approve.
  if (data.automaticPreparationEnabled && !data.active &&
      !['publication_queued', 'publishing', 'publication_uncertain', 'reconciliation_required'].includes(data.status)) {
    const prepared = await prepareFlowForReview(questionnaire, getState, undefined,
      { ...options, initialData: data });
    if (!prepared) throw new Error('Flow preparation could not be confirmed before approval.');
  }
  await axios.post(`${base}/approve`, {}, config);
  return true;
}
